export default "__VITE_ASSET__yEZePWr$__"